import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import { useState } from 'react';
import { ReportWrapper } from './ReportWrapper';
import { FilterReports } from './Filter';
import { Main } from './styles';

export const Reports = (): JSX.Element => {
  const options = ['Prevenções de Perdas'];

  const [selectedPeriodRecent, setSelectedPeriodRecent] = useState(options[0]);

  const handlePeriodRecent = option => {
    setSelectedPeriodRecent(option);
  };

  return (
    <>
      <Header />
      <Menu />
      <Main>
        <FilterReports
          handlePeriodRecent={handlePeriodRecent}
          selectedPeriodRecent={selectedPeriodRecent}
          options={options}
        />
        <ReportWrapper title="Relatórios" />
      </Main>
    </>
  );
};
